/* tslint:disable */
/* eslint-disable */
/**
 * Bericht Einreichen
 * RVC und DBBG Berichte in das Berichtsmanagement einreichen.
 *
 * The version of the OpenAPI document: 1.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiFehlerMeldungParameter
 */
export interface ApiFehlerMeldungParameter {
    /**
     * 
     * @type {string}
     * @memberof ApiFehlerMeldungParameter
     */
    type?: ApiFehlerMeldungParameterTypeEnum;
    /**
     * Typ ist abhängig von "type"-Feld.
     * @type {any}
     * @memberof ApiFehlerMeldungParameter
     */
    value?: any | null;
}


/**
 * @export
 */
export const ApiFehlerMeldungParameterTypeEnum = {
    String: 'string',
    Integer: 'integer',
    Decimal: 'decimal',
    Date: 'date',
    DateTime: 'date-time'
} as const;
export type ApiFehlerMeldungParameterTypeEnum = typeof ApiFehlerMeldungParameterTypeEnum[keyof typeof ApiFehlerMeldungParameterTypeEnum];


/**
 * Check if a given object implements the ApiFehlerMeldungParameter interface.
 */
export function instanceOfApiFehlerMeldungParameter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApiFehlerMeldungParameterFromJSON(json: any): ApiFehlerMeldungParameter {
    return ApiFehlerMeldungParameterFromJSONTyped(json, false);
}

export function ApiFehlerMeldungParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFehlerMeldungParameter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ApiFehlerMeldungParameterToJSON(value?: ApiFehlerMeldungParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'value': value.value,
    };
}

